var React = require('react');

function LockAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M152 225H72v-72C72 69.2 140.2 1 224 1s152 68.2 152 152v72h-80v-72a72 72 0 0 0-144 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M400 225H48a48 48 0 0 0-48 48v192a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V273a48 48 0 0 0-48-48zM264 392a40 40 0 0 1-80 0v-48a40 40 0 0 1 80 0z","className":"fa-primary","key":2})]);
}

LockAlt.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = LockAlt;

LockAlt.default = LockAlt;
